import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Icon } from 'antd';
import { cloneDeep } from 'lodash';

import { routeGenerator } from 'routes';
import TreeList from 'shared/components/Tree/TreeList';
import { isSupervisorUser } from 'Auth/redux/auth.redux';
import { deleteSection, moveSection, saveSection } from 'Root/http';
import { unflattenEntities, updateTreeData } from 'shared/components/Tree/treeUtils';

import SectionModal from './SectionModal';
import TreeNode from './TreeNode';

import s from './style/Sidebar.pcss';


const setIndentTree = tree =>
  tree.map(node => ({ ...node, indent: node.weightIndex * 20 }));

@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class Sidebar extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    isSupervisor: PropTypes.bool.isRequired,
    history: PropTypes.shape().isRequired,
    match: PropTypes.shape().isRequired,
    onLoadData: PropTypes.func.isRequired,
  };

  state = {
    treeData: this.props.data,
    editMode: false,
    editedSection: undefined,
    name: '',
  };

  componentDidMount() {
    this.setState({ treeData: this.props.data }, () => this.expandTree(this.props));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.length !== nextProps.data.length) {
      this.setState({ treeData: nextProps.data }, () => this.expandTree(nextProps));
    }
  }

  expandTree = (props) => {
    const { treeData } = this.state;
    const expandedId = props.match.params.sectionId || null;
    const updatedData = updateTreeData(treeData, expandedId, 'parentSectionId');
    this.setState({ treeData: updatedData });
  };

  onExpandTree = (node) => {
    const sectionId = node.id;
    const { treeData } = this.state;
    const { history, match } = this.props;
    const linkId = match.params.sectionId === sectionId
      ? (node.parentSectionId === 'null' ? '' : node.parentSectionId)
      : sectionId;
    history.push({
      pathname: routeGenerator.sectionLink(linkId),
    });
    const updatedData = updateTreeData(treeData, sectionId, 'parentSectionId');
    this.setState({ treeData: updatedData }, () => this.expandTree(this.props));
  };

  onEditMode = (editMode, editedSection = undefined) =>
    this.setState({ editMode, editedSection });

  handleEdit = body => new Promise(resolve =>
    saveSection(body).then((data) => {
      const treeData = this.state.treeData;
      if (body.id) {
        const editedSection = treeData.find(g => g.id === body.id);
        editedSection.name = data.name;
        this.setState({ editMode: false, treeData });
      } else {
        this.props.onLoadData();
        this.setState({ editMode: false });
      }
      return resolve();
    }),
  );

  onRemoveNode = sectionId =>
    deleteSection(sectionId).then(async () => {
      await this.props.onLoadData();
      return Promise.resolve();
    });

  onDrop = (data) => {
    const { dragNode, dropPosition, dropToGap, node } = data;
    const treeData = cloneDeep(this.state.treeData);
    if (!dropToGap || (node.props.node.parentSectionId !== dragNode.props.node.parentSectionId)) {
      return;
    }
    const nearNodes = this.state.treeData
      .filter(td => td.parentSectionId === node.props.node.parentSectionId)
      .sort((a, b) => a.order - b.order);
    const placeNode = nearNodes.find(nd => nd.id === node.props.node.id);
    const dropNodeIndex = nearNodes.indexOf(placeNode);
    let newOrder = 1; // insert into start of list by default
    const addOrderCount = dragNode.props.node.order < node.props.node.order ? 0 : 1;
    if (dropNodeIndex > dropPosition) {
      const prevNode = nearNodes[dropNodeIndex - 1];
      if (prevNode) {
        newOrder = prevNode.order + addOrderCount;
      } else {
        // insert before the first element
        newOrder = nearNodes[0].order - addOrderCount;
      }
    } else {
      newOrder = placeNode.order + addOrderCount;
    }
    moveSection({ id: dragNode.props.node.id, order: newOrder })
      .then((res) => {
        const children = res.newOrderList;
        children.forEach((child) => {
          const sameTreeNode = treeData.find(td => td.id === child.id);
          sameTreeNode.order = child.order;
        });
        this.setState({ treeData });
      });
  };

  render() {
    const { treeData, editMode, editedSection } = this.state;
    const sortedData = treeData.sort((a, b) => a.order - b.order);
    const expandedKeys = sortedData.filter(item => item.isExpanded).map(item => item.id);
    const indentedTree = setIndentTree(sortedData);
    const tree = unflattenEntities(indentedTree, 'id', 'parentSectionId');
    const dragProps = this.props.isSupervisor
      ? {}
      : { draggable: true, onDrop: this.onDrop };
    return (
      <div className={s.sidebar}>
        <div className={s.sidebarLabel}>Дерево разделов</div>
        <div className={s.treeContainer}>
          <TreeList
            tree={tree}
            dragProps={dragProps}
            treeNode={node => (
              <TreeNode
                node={node}
                isSelected={expandedKeys.includes(node.id)}
                onRemove={this.onRemoveNode}
                onEdit={() => this.onEditMode(true, node)}
              />
            )}
            expandedKeys={expandedKeys}
            onExpand={this.onExpandTree}
          />
        </div>
        <div className={s.addContainer} onClick={() => this.onEditMode(true)}>
          <Icon type="plus" theme="outlined" />
          <div className={s.addBtn}>Добавить уровень разделов</div>
        </div>
        <SectionModal
          visible={editMode}
          section={editedSection}
          onClose={() => this.onEditMode(false)}
          items={sortedData}
          onEdit={this.handleEdit}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Sections/Sidebar/Sidebar.js